/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  CreateTunneledMcpServerForm,
  CreateTunneledMcpServerForm$Outbound,
  CreateTunneledMcpServerForm$outboundSchema,
} from "../components/createtunneledmcpserverform.js";

export type CreateTunneledMcpServerSecurityOption1 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type CreateTunneledMcpServerSecurityOption2 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type CreateTunneledMcpServerSecurity = {
  option1?: CreateTunneledMcpServerSecurityOption1 | undefined;
  option2?: CreateTunneledMcpServerSecurityOption2 | undefined;
};

export type CreateTunneledMcpServerRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  createTunneledMcpServerForm: CreateTunneledMcpServerForm;
};

/** @internal */
export type CreateTunneledMcpServerSecurityOption1$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const CreateTunneledMcpServerSecurityOption1$outboundSchema:
  z.ZodMiniType<
    CreateTunneledMcpServerSecurityOption1$Outbound,
    CreateTunneledMcpServerSecurityOption1
  > = z.pipe(
    z.object({
      projectSlugHeaderGramProject: z.string(),
      sessionHeaderGramSession: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function createTunneledMcpServerSecurityOption1ToJSON(
  createTunneledMcpServerSecurityOption1:
    CreateTunneledMcpServerSecurityOption1,
): string {
  return JSON.stringify(
    CreateTunneledMcpServerSecurityOption1$outboundSchema.parse(
      createTunneledMcpServerSecurityOption1,
    ),
  );
}

/** @internal */
export type CreateTunneledMcpServerSecurityOption2$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const CreateTunneledMcpServerSecurityOption2$outboundSchema:
  z.ZodMiniType<
    CreateTunneledMcpServerSecurityOption2$Outbound,
    CreateTunneledMcpServerSecurityOption2
  > = z.pipe(
    z.object({
      apikeyHeaderGramKey: z.string(),
      projectSlugHeaderGramProject: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        apikeyHeaderGramKey: "apikey_header_Gram-Key",
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      });
    }),
  );

export function createTunneledMcpServerSecurityOption2ToJSON(
  createTunneledMcpServerSecurityOption2:
    CreateTunneledMcpServerSecurityOption2,
): string {
  return JSON.stringify(
    CreateTunneledMcpServerSecurityOption2$outboundSchema.parse(
      createTunneledMcpServerSecurityOption2,
    ),
  );
}

/** @internal */
export type CreateTunneledMcpServerSecurity$Outbound = {
  Option1?: CreateTunneledMcpServerSecurityOption1$Outbound | undefined;
  Option2?: CreateTunneledMcpServerSecurityOption2$Outbound | undefined;
};

/** @internal */
export const CreateTunneledMcpServerSecurity$outboundSchema: z.ZodMiniType<
  CreateTunneledMcpServerSecurity$Outbound,
  CreateTunneledMcpServerSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => CreateTunneledMcpServerSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => CreateTunneledMcpServerSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function createTunneledMcpServerSecurityToJSON(
  createTunneledMcpServerSecurity: CreateTunneledMcpServerSecurity,
): string {
  return JSON.stringify(
    CreateTunneledMcpServerSecurity$outboundSchema.parse(
      createTunneledMcpServerSecurity,
    ),
  );
}

/** @internal */
export type CreateTunneledMcpServerRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
  "Gram-Project"?: string | undefined;
  CreateTunneledMcpServerForm: CreateTunneledMcpServerForm$Outbound;
};

/** @internal */
export const CreateTunneledMcpServerRequest$outboundSchema: z.ZodMiniType<
  CreateTunneledMcpServerRequest$Outbound,
  CreateTunneledMcpServerRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    gramKey: z.optional(z.string()),
    gramProject: z.optional(z.string()),
    createTunneledMcpServerForm: CreateTunneledMcpServerForm$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramKey: "Gram-Key",
      gramProject: "Gram-Project",
      createTunneledMcpServerForm: "CreateTunneledMcpServerForm",
    });
  }),
);

export function createTunneledMcpServerRequestToJSON(
  createTunneledMcpServerRequest: CreateTunneledMcpServerRequest,
): string {
  return JSON.stringify(
    CreateTunneledMcpServerRequest$outboundSchema.parse(
      createTunneledMcpServerRequest,
    ),
  );
}
